var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallerTutoringPattern = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 306,
  height: 215,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#smaller-tutoring-pattern_svg__a)",
  stroke: "#607189",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M.75 8.77c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.502.172 1.391-.556 1.391H1.557a.807.807 0 0 1-.807-.807V8.77ZM47.598 40.338a.807.807 0 0 0-1.364-.585l-10.897 10.38c-.528.502-.172 1.39.556 1.39h10.898a.807.807 0 0 0 .807-.806v-10.38Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 12.137,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 45.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.098 8.77c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.502.172 1.391-.557 1.391H65.904a.807.807 0 0 1-.806-.807V8.77ZM111.945 40.338a.807.807 0 0 0-1.363-.585l-10.898 10.38c-.527.502-.172 1.39.557 1.39h10.897a.807.807 0 0 0 .807-.806v-10.38Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 12.137,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72.348,
  cy: 45.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.445 8.77c0-.71.85-1.074 1.364-.585l10.897 10.379c.528.502.172 1.391-.556 1.391h-10.898a.807.807 0 0 1-.807-.807V8.77ZM176.293 40.338a.807.807 0 0 0-1.363-.585l-10.898 10.38c-.527.502-.172 1.39.556 1.39h10.898a.807.807 0 0 0 .807-.806v-10.38Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 12.137,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136.695,
  cy: 45.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.793 8.77c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.502.172 1.391-.556 1.391H194.6a.807.807 0 0 1-.807-.807V8.77ZM240.641 40.338a.807.807 0 0 0-1.364-.585l-10.897 10.38c-.528.502-.172 1.39.556 1.39h10.898a.807.807 0 0 0 .807-.806v-10.38Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 12.137,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 201.043,
  cy: 45.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M258.141 8.77a.807.807 0 0 1 1.363-.585l10.898 10.379c.527.502.172 1.391-.557 1.391h-10.898a.807.807 0 0 1-.806-.807V8.77ZM304.988 40.338a.807.807 0 0 0-1.363-.585l-10.898 10.38c-.527.502-.172 1.39.557 1.39h10.897a.807.807 0 0 0 .807-.806v-10.38Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 12.137,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 265.391,
  cy: 45.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M.75 71.906c0-.71.85-1.073 1.363-.584L13.011 81.7c.527.502.172 1.39-.556 1.39H1.557a.807.807 0 0 1-.807-.806V71.906ZM47.598 103.474a.807.807 0 0 0-1.364-.584l-10.897 10.379c-.528.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 75.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 108.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.098 71.906c0-.71.85-1.073 1.363-.584L77.359 81.7c.527.502.172 1.39-.557 1.39H65.904a.807.807 0 0 1-.806-.806V71.906ZM111.945 103.474a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 75.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72.348,
  cy: 108.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.445 71.906c0-.71.85-1.073 1.364-.584L141.706 81.7c.528.502.172 1.39-.556 1.39h-10.898a.807.807 0 0 1-.807-.806V71.906ZM176.293 103.474a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 75.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136.695,
  cy: 108.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.793 71.906c0-.71.85-1.073 1.363-.584L206.054 81.7c.527.502.172 1.39-.556 1.39H194.6a.807.807 0 0 1-.807-.806V71.906ZM240.641 103.474a.807.807 0 0 0-1.364-.584l-10.897 10.379c-.528.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 75.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 201.043,
  cy: 108.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M258.141 71.906a.807.807 0 0 1 1.363-.584L270.402 81.7c.527.502.172 1.39-.557 1.39h-10.898a.807.807 0 0 1-.806-.806V71.906ZM304.988 103.474a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 75.273,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 265.391,
  cy: 108.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M.75 135.043c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.503.172 1.391-.556 1.391H1.557a.807.807 0 0 1-.807-.806v-10.379ZM47.598 166.611a.807.807 0 0 0-1.364-.584l-10.897 10.379c-.528.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 138.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 171.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.098 135.043c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.503.172 1.391-.557 1.391H65.904a.806.806 0 0 1-.806-.806v-10.379ZM111.945 166.611a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 138.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72.348,
  cy: 171.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.445 135.043c0-.71.85-1.074 1.364-.585l10.897 10.379c.528.503.172 1.391-.556 1.391h-10.898a.807.807 0 0 1-.807-.806v-10.379ZM176.293 166.611a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 138.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136.695,
  cy: 171.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.793 135.043c0-.71.85-1.074 1.363-.585l10.898 10.379c.527.503.172 1.391-.556 1.391H194.6a.806.806 0 0 1-.807-.806v-10.379ZM240.641 166.611a.807.807 0 0 0-1.364-.584l-10.897 10.379c-.528.502-.172 1.391.556 1.391h10.898a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 138.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 201.043,
  cy: 171.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M258.141 135.043a.807.807 0 0 1 1.363-.585l10.898 10.379c.527.503.172 1.391-.557 1.391h-10.898a.806.806 0 0 1-.806-.806v-10.379ZM304.988 166.611a.807.807 0 0 0-1.363-.584l-10.898 10.379c-.527.502-.172 1.391.557 1.391h10.897a.807.807 0 0 0 .807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 138.41,
  r: 6.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 265.391,
  cy: 171.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M.75 198.179a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.556 1.391H1.557a.807.807 0 0 1-.807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40.348,
  cy: 201.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.098 198.179a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.557 1.391H65.904a.807.807 0 0 1-.806-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104.695,
  cy: 201.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.445 198.179a.807.807 0 0 1 1.364-.584l10.897 10.379c.528.502.172 1.391-.556 1.391h-10.898a.807.807 0 0 1-.807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169.043,
  cy: 201.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.793 198.179a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.556 1.391H194.6a.807.807 0 0 1-.807-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 233.391,
  cy: 201.547,
  r: 6.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M258.141 198.179a.807.807 0 0 1 1.363-.584l10.898 10.379c.527.502.172 1.391-.557 1.391h-10.898a.806.806 0 0 1-.806-.807v-10.379Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 297.738,
  cy: 201.547,
  r: 6.25
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "smaller-tutoring-pattern_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h306v215H0z"
})))));
export default SvgSmallerTutoringPattern;